<template>
  <div style="width:100%;">
    <div class="body_top" v-if="!props_.type">
      <div class="bg_img_div">
        <!-- <img src="../../assets/newYXSZAL.png" /> -->
      </div>
      <!-- 绝对定位 -->
      <!-- <div class="ag_select">
						<span v-for="(index) in bottomList" :key="index"
							:class="index.checked== true ? 'ag_selectT' : 'ag_selectF'"
							@click="selectClick(index)">{{index.title}}</span>
					</div> -->
      <div class="body_top_abs">
        <div class="img_he">
          <img class="log_Img" :src="require('@/assets/herder_logo1.png')" alt="" />
        </div>
        <p class="bt1">标识山西影像资源共享平台</p>
        <div class="body_top_abs_gn">
          <div class="ag_l">
            <div class="ss_abs_c_srk">
              <input placeholder="输入作品类型、名称等进行搜索" v-model="from.keyWord" @keyup.enter="getkeyWord" />
              <div @click="getkeyWord()" class="cur">
                <img src="../../assets/yxsc_ss.png" />
                搜索
              </div>
            </div>
          </div>
          <div class="log_box">
            <!-- <img src="@/assets/log1.png" />
            <p>x</p>
            <img src="@/assets/log2.png" />
            <p>x</p>
            <img src="@/assets/log3.png" /> -->
          </div>
        </div>
        <!-- <p class="bt1">标识山西影像资源共享平台</p> -->
        <!-- <p class="bt2">用正版，更放心</p> -->
        <!-- <div class="body_top_abs_gn">
          <div class="ag_l">
            <div class="ss_abs_c_srk">
              <input
                placeholder="输入作品类型、名称等进行搜索"
                v-model="from.keyWord"
                @keyup.enter="getkeyWord"
              />
              <div @click="getkeyWord()" class="cur">
                <img src="../../assets/yxsc_ss.png" />
                搜索
              </div>
            </div>
          </div>
        </div> -->
      </div>
    </div>
    <div style="width: 12.8rem; margin: 0 auto; display: block" v-if="!props_.type">
      <div class="worksClassify">
        <div class="directionTitle">类型</div>
        <div class="directionList">
          <span v-for="index in worksClassify" :key="index" @click="worksClassifyClick(index)"
            :class="index.checked == true ? 'directionListY cur' : 'cur'">{{ index.title }}</span>
        </div>
      </div>
      <div class="SL_classify" style="width: 100%">
        <div class="SL_classify_top" style="width: 100%">
          <dropDown :boxRef="topParams" @tabClick="handleTab"></dropDown>
        </div>
      </div>
      <div class="worksClassifyBody">
        <div class="wCB_select"></div>
        <div class="SL_classify_body">
          <el-row :gutter="20">
            <el-col style="margin-top: 0.32rem" :span="6" v-for="(item, index) in list" :key="index">
              <moduleWorks :item="item" class="SL_CB_list cur" @click="ParticularsFun(item)"></moduleWorks>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
    <!-- 待 -->
    <el-dialog @keyup.esc="openClick" v-model="Particulars" :show-close="false" align-center width="800px"
      :close-on-click-modal="false">
      <ShadowIndexWParticulars ref="ShadowIndexWParticularsRef" @openShowInfo="openShowinfo" @openClickA="openClickA"
        @openClickOverClose="openClickOverClose" :workId="workID" @openClickOverOpen="openClickOverOpen" :style="ParticularsOverflowY == false
          ? 'overflow-y: auto;'
          : 'overflow-y: clip;'
          " class="Particulars">
      </ShadowIndexWParticulars>
    </el-dialog>

    <div style="margin-top: 0.4rem; margin-bottom: 0.6rem" v-if="!props_.type">
      <!-- <el-pagination style="" layout="prev, pager, next" :total="1000" /> -->
      <el-pagination v-if="list.length != 0" v-model:current-page="from.pageIndex" v-model:page-size="from.pageSize"
        @size-change="sizeChange" @current-change="currentChange" style="margin: 0.4rem 0" background
        layout="prev, pager, next" :total="from.total" />
    </div>
    <div class="" v-if="list.length == 0 && !props_.type" style="margin-top: -95px;">
      <el-empty description="暂无数据" />
    </div>
  </div>
</template>

<script setup>
import { ref, nextTick } from "vue";
import { useRouter } from "vue-router";
import { Axios } from "../../assets/js/ls_com_axios.js";
import moduleWorks from "../../components/moduleWorks.vue";
import ShadowIndexWParticulars from "../../components/ShadowIndexWParticulars.vue";
import dropDown from "../../components/comTemplate/drop-down1.vue";

document.title = "标识山西-找案例";
const props_ = defineProps({
  data_monthly: { type: Array, default: () => { } },
  type: { type: String, default: "" },
})
const router = useRouter();
const worksClassify = ref([]);
let keyWord = ref("");
let workID = ref("");
let from = ref({
  condition: {
    recommendType: '4', // 1首页推荐 2编辑推荐 , 3葡萄推荐
    category1_id: null, // 	类目ID
    categoryId: null, // 	类目ID
    videoDefinition: null,
    // publish_mode: 2,  不需要
  },
  keyWord: "",
  startTime: null,
  endTime: null,
  pageIndex: 1,
  pageSize: 8,
  // sort: "id",
  //  sort: 'likes',
  total: 0,
});
let inputTitle = router.currentRoute.value.query.inputTitle;
from.value.keyWord = inputTitle || "";
nextTick();
const list = ref([]);
const topParams = ref({
  left: [
    {
      name: "热门推荐",
      value: "11",
    },
    {
      name: "全部作品",
      value: "44",
    },
    {
      name: "最新作品",
      value: "2",
      listShow: false,
    },
    // {
    //   name: "我的关注",
    //   value: "3",
    //   listShow: false,
    // },
  ],
  right: [
    {
      name: "全部时长",
      value: "4",
      listShow: true,
      list: [
        {
          name: "全部时长",
          value: "",
        },
        {
          name: "1分钟以下",
          value: "1-60",
        },
        {
          name: "1-5分钟",
          value: "60-300",
        },
        {
          name: "5-10分钟",
          value: "300-600",
        },
        {
          name: "10分钟以上",
          value: "600",
        },
      ],
    },
    {
      name: "全部清晰度",
      value: "5",
      listShow: true,
      list: [
        {
          name: "全部清晰度",
          value: "",
        },
        {
          name: "标清",
          value: "标清",
        },
        {
          name: "高清",
          value: "高清",
        },
        {
          name: "全高清",
          value: "全高清",
        },
        {
          name: "2K",
          value: "2K",
        },
        {
          name: "4K",
          value: "4k",
        },
        {
          name: "8K",
          value: "8k",
        },
        {
          name: "16K",
          value: "16k",
        },
      ],
    },
  ],
});
// const topParams = ref({
//   left: [
//     {
//       name: "首页推荐",
//       value: "1",
//       listShow: true,
//       list: [
//         {
//           name: "首页推荐",
//           value: "1",
//         },
//         {
//           name: "编辑推荐",
//           value: "2",
//         },
//         {
//           name: "普通推荐",
//           value: "3",
//         },
//         {
//           name: "全部作品",
//           value: "4",
//         },
//       ],
//     },
//     {
//       name: "最新作品",
//       value: "2",
//       listShow: false,
//     },
//     {
//       name: "我的关注",
//       value: "3",
//       listShow: false,
//     },
//   ],
//   right: [
//     {
//       name: "全部时长",
//       value: "4",
//       listShow: true,
//       list: [
//         {
//           name: "全部时长",
//           value: "",
//         },
//         {
//           name: "1分钟以下",
//           value: "1-60",
//         },
//         {
//           name: "1-5分钟",
//           value: "60-300",
//         },
//         {
//           name: "5-10分钟",
//           value: "300-600",
//         },
//         {
//           name: "10分钟以上",
//           value: "600",
//         },
//       ],
//     },
//     {
//       name: "全部清晰度",
//       value: "5",
//       listShow: true,
//       list: [
//         {
//           name: "全部清晰度",
//           value: "",
//         },
//         {
//           name: "标清",
//           value: "标清",
//         },
//         {
//           name: "高清",
//           value: "高清",
//         },
//         {
//           name: "全高清",
//           value: "全高清",
//         },
//         {
//           name: "2K",
//           value: "2K",
//         },
//         {
//           name: "4K",
//           value: "4k",
//         },
//         {
//           name: "8K",
//           value: "8k",
//         },
//         {
//           name: "16K",
//           value: "16k",
//         },
//       ],
//     },
//   ],
// });
const type = ref(0);
/* 获取分类类目 */
!props_.type && Axios(
  "POST",
  "/material/material/workCategory/list",
  {
    pageIndex: 1,
    pageSize: 999,
  },
  false,
  function (res) {
    let records = res.data.data.records;
    for (let i = 0; i < records.length; i++) {
      if (records[i].name == '全部') {
        worksClassify.value.push({
          title: records[i].name,
          id: records[i].id,
          checked: true,
        });
      } else {
        worksClassify.value.push({
          title: records[i].name,
          id: records[i].id,
          checked: false,
        });
      }
    }
  }
);
const getkeyWord = function () {
  window.scrollTo(0, 600);
  // from.value.keyWord = keyWord.value;
  if (type.value > 0) {
    getFlowerlist();
  } else {
    getlist();
  }
};
// ESC 关闭视频的事件
const openClick = () => {
  ShadowIndexWParticularsRef.value.openClick();
};
/* 获取数据列表 */
const getlist = function (e) {
  let obj = { ...from.value };
  let obj1 = { ...from.value.condition };

  for (let key in obj) {
    if (obj[key] === "" || obj[key] === null || obj[key] === undefined) {
      delete obj[key];
    }
  }
  for (let key in obj1) {
    if (obj1[key] === "" || obj1[key] === null || obj1[key] === undefined) {
      delete obj1[key];
    }
  }
  // obj1.recommendType == 4 ? delete obj1.recommendType : "";
  obj.condition = obj1;
  if (e) {
    type.value = 0;
  }
  try {
    Axios("POST", "/material/material/work/list", obj, null, function (res) {
      list.value = res.data.data.records;
      from.value.total = res.data.data.total;
    });
  } catch (err) {
    console.log(err);
  }
};
const getFlowerlist = function () {
  let obj = { ...from.value };
  let obj1 = { ...from.value.condition };

  for (let key in obj) {
    if (obj[key] === "" || obj[key] === null || obj[key] === undefined) {
      delete obj[key];
    }
  }
  for (let key in obj1) {
    if (obj1[key] === "" || obj1[key] === null || obj1[key] === undefined) {
      delete obj1[key];
    }
  }
  obj.condition = obj1;
  type.value++;
  Axios(
    "POST",
    "/material/material/work/flowerList",
    obj,
    null,
    function (res) {
      res.data.data ? (list.value = res.data.data.records) : (list.value = []);
    }
  );
};
const handleTab = function (...data) {
  console.log(
    "🚀 ~ file: ShadowIndexAllWorks.vue:311 ~ handleTab ~ data:",
    data
  );
  const params = JSON.parse(JSON.stringify(topParams.value));
  if (data[0] == "1") {
    if (data[3].name) {
      params.left[0].name = data[3].name;
      from.value.condition.recommendType = data[3].value;
      // from.value.sort = "id";
    } else {
      from.value.condition.recommendType = "1";
    }
    getlist();
  } else if (data[0] == "2") {
    delete from.value.condition.recommendType;
    getlist(true);
  } else if (data[0] == "3") {
    delete from.value.condition.recommendType;
    getFlowerlist();
  } else if (data[0] == "4") {
    if (data[3].name) {
      params.right[0].name = data[3].name;
      if (data[1]) {
        var times = data[1].split("-");
        from.value.startTime = times[0];
        from.value.endTime = times[1];
      } else {
        from.value.startTime = null;
        from.value.endTime = null;
      }
    }
    if (type.value > 0) {
      getFlowerlist();
    } else {
      getlist();
    }
  } else if (data[0] == "5") {
    if (data[3].name) {
      params.right[1].name = data[3].name;
      from.value.condition.videoDefinition = data[1];
    } else {
      from.value.condition.videoDefinition = null;
    }
    if (type.value > 0) {
      getFlowerlist();
    } else {
      getlist();
    }
  } else if (data[0] == "44") {
    // params.left[0].name = '热门推荐';
    from.value.condition.recommendType = '';
    getlist();
  } else if (data[0] == "11") {
    // params.left[1].name = '全部作品';
    from.value.condition.recommendType = 4;
    getlist();
  }
  /*

  */
  topParams.value = params;
};
const worksClassifyClick = function (index) {
  for (let i = 0; i < worksClassify.value.length; i++) {
    if (worksClassify.value[i] == index) {
      worksClassify.value[i].checked = true;
      //   from.value.condition.category1_id = worksClassify.value[i].id;
      from.value.condition.categoryId = worksClassify.value[i].id;
    } else {
      worksClassify.value[i].checked = false;
    }
  }
  if (type.value > 0) {
    getFlowerlist();
  } else {
    getlist();
  }
  // getlist();
};
// const bodyStyle = document.body.style;
const Particulars = ref(false);
const ParticularsOverflowY = ref(false);
const ShadowIndexWParticularsRef = ref();
const ParticularsFun = async function (item) {
  workID.value = item.id;
  // bodyStyle.overflowY = "hidden";
  Particulars.value = true;
  // await nextClick();
  setTimeout(() => {
    ShadowIndexWParticularsRef.value
      ? ShadowIndexWParticularsRef.value.init()
      : "";
  }, 50);

  // bodyStyle.overflowY = "hidden";
};
nextTick(() => {
  props_.type == 'no' && ParticularsFun(props_.data_monthly)
});
const edit_click = defineEmits(["cancel"]);
const openClickA = function () {
  Particulars.value = false;
  edit_click("cancel", false);
  // bodyStyle.overflowY = "clip";
};
const openClickOverClose = function () {
  ParticularsOverflowY.value = true; // 关闭
};
const openClickOverOpen = function () {
  ParticularsOverflowY.value = false; // 打来
};
const openShowinfo = function (id) {
  Particulars.value = false;
  workID.value = id;

  setTimeout(() => {
    Particulars.value = true;
  }, 50);
};
const sizeChange = function (val) {
  getlist();
};
const currentChange = function (val) {
  console.log(val);
  from.value.pageIndex = val;
  getlist();
};
const prevClick = function (val) {
  console.log(val);
  from.value.pageIndex = val;
  getlist();
};
const nextClick = function (val) {
  from.value.pageIndex = val;
  getlist();
};
!props_.type && getlist();
</script>

<style scoped lang="less">
.SL_CB_list {
  width: 3.02rem;
  margin-top: 0.16rem;
}

.worksClassify {
  /* padding: 0.24rem; */
  padding: 0.24rem 0.24rem 0 0.24rem;
  background: #f5f5f5;
  border-radius: 0.08rem;
  margin-top: 0.3rem;
}

.worksClassify,
.directionList,
.wCB_select {
  display: flex;
  flex-direction: row;
  /* align-items: center; */
  justify-content: flex-start;
  align-items: flex-start;
}

.wCB_select {
  justify-content: space-between;
}

.directionList {
  flex-wrap: wrap;
}

.directionTitle {
  margin-right: 0.4rem;
  border-radius: 1rem 0rem 1rem 1rem;
  background: #C01A26;
  font-size: 0.14rem;
  color: #ffffff;
  padding: 0.06rem 0.16rem;
  display: block;
  white-space: nowrap;
}

.directionList span {
  width: 1rem;
  padding: 0.04rem 0;
  margin-right: 0.12rem;
  margin-bottom: 0.24rem;
  display: block;
  font-size: 0.14rem;
  color: #86909c;
  text-align: center;
}

.directionListY {
  background: rgba(41, 120, 255, 0.2);
  color: #C01A26 !important;
  border-radius: 1rem 1rem 1rem 1rem;
}

.SL_classify_body {
  margin-bottom: 1rem;
}

.Particulars {
  z-index: 999;
  position: fixed;
  top: 0;
  left: 0;
  width: calc(100vh);
  height: calc(100vh);
  /* min-height: calc(100vh); */
  background: rgba(0, 0, 0, 0.8);
}

/* 下拉样式 */
.SL_classify {
  display: flex;
  width: 100%;
  margin-top: 0.3rem;
}

.flex-grow {
  flex-grow: 1;
  // width: 40%;
}

.menu-container {
  display: flex;
}

.body_top {
  width: 100%;
  /* height: 3.5rem; */
  background: rgba(0, 0, 0, 0.3);
  position: relative;
}

.bg_img_div {
  width: 100%;
  height: 7rem;
  position: relative;
  // z-index: -1;
  // background: rgba(0, 0, 0, 0.3);
  // overflow: hidden;
  background: url("../../assets/newYXSZAL.png") no-repeat bottom center;
  background-size: auto 100%;
}

.bg_img_div>img {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

.body_top_abs {
  display: flex;
  flex-direction: column;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.3);
}

.body_top_abs>.img_he {
  width: 100%;
  text-align: center;
  margin-top: 1.3rem;
}

.log_Img {
  text-align: center;
  width: 2.8rem;
}

.bt1 {
  margin-top: 0.1rem;
  color: #ffffff;
  font-size: 0.3rem;
  text-align: center;
}

.bt2 {
  margin-top: 0.08rem;
  font-size: 0.16rem;
  color: #ffffff;
  text-align: center;
}

.body_top_abs_gn {
  flex: 1;
  position: relative;
  width: 7.5rem;
  margin: 0 auto;
  margin-top: 0.1rem;
}

.ag_l {
  width: 100%;
  display: flex;
  justify-content: initial;
  align-items: center;
  padding-top: 0.8rem;
}

.ss_abs_c_srk {
  width: 8rem;
  display: flex;
  overflow: hidden;
  border-radius: 0.08rem;
}

.ss_abs_c_srk>input {
  flex-grow: 1;
  font-size: 0.14rem;
  border: 0rem solid #fff;
  padding: 0.16rem;
}

.ss_abs_c_srk>div {
  font-size: 0.14rem;
  color: #ffffff;
  background: #C01A26;
  padding: 0.16rem 0.24rem;
  display: flex;
  align-items: center;
}

.ss_abs_c_srk>div>img {
  width: 0.16rem;
  margin-right: 0.06rem;
}

.ss_abs_c_srk>div>input {
  border: 0rem solid #fff;
  background: #fff;
}

.log_box {
  position: absolute;
  bottom: 0.4rem;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 0.6rem;
  width: 100%;

  img {
    // width: 1.2rem;
    height: 0.4rem;

    &:nth-of-type(2) {
      margin: 0 0.24rem;
    }
  }

  p {
    color: #fff;
    padding: 0 0.21rem;
  }
}

/* 分页 */

.el-pagination {
  justify-content: center;
}

/deep/.el-pager li {
  padding: 0.06rem;
  margin: 0 0.03rem;
}

/deep/.el-pager li.is-active {
  color: #fff;
  background: #C01A26;
}

/deep/.el-pager li:hover {
  color: #fff;
  background: #C01A26;
}

/deep/ .el-pagination.is-background .el-pager li.is-active {
  background: #C01A26;
}

/deep/.el-popper:focus {
  outline: none !important;
}
</style>
